<template>
  <div class="digital">
    <h1 class="com-title com-ht">
      <i></i>数字证书授权 <span style="font-size: 12px; color: #ec1c1c">（将数字证书与特定的模板绑定，授权给调用平台使用数字证书，保障数字证书的安全）</span>
    </h1>
    <div class="box-wrap">
      <el-form ref="ruleForm" :inline="true" :rules="rules" :model="formInline">
        <el-form-item label="输入模板编码：" prop="tplId" style="margin-bottom: 0">
          <el-input size="small" v-model="formInline.tplId" placeholder="输入模板编码"></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 0">
          <el-button size="small" type="primary" @click="searchTemp('ruleForm')">查看模板内容</el-button>
        </el-form-item>
      </el-form>
      <div class="line">
        <p v-if="tplNo"><span style="margin-right: 14px">模板编码：{{ tplNo }}</span><span>模板名称：{{ tplName }}</span></p>
        <a @click="openLog">去查看授权记录 <i class="el-icon-arrow-right el-icon--right"></i></a>
      </div>
      <div class="content">
        <template v-if="htmlContent">
          <div id="htmlContent" v-html="htmlContent"></div>
        </template>
        <template v-else>
          <p class="tips">暂无模板数据</p>
        </template>
      </div>
      <el-form ref="ruleForm1" :inline="true" :rules="rules" :model="formInline">
        <el-form-item label="被授权人邮箱：" prop="email" style="margin-bottom: 0">
          <el-input size="small" v-model="formInline.email" placeholder="被授权人邮箱"></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 0">
          <el-button size="small" type="primary" @click="createCode('ruleForm1')">确认生成授权码并授权</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      title="授权记录列表"
      :visible.sync="logDialog"
      width="45%"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <el-table
        :data="this.logList"
        border
        stripe
        max-height="300"
        :header-cell-style="{ background: '#f9f9f9', color: '#333333' }"
        class="table"
      >
        <el-table-column prop="authedCompany" label="被授权单位"></el-table-column>
        <el-table-column prop="authEmail" label="被授权单位邮箱"></el-table-column>
        <el-table-column prop="tplNo" label="模板ID"></el-table-column>
        <el-table-column prop="authTime" label="授权时间"></el-table-column>
        <el-table-column prop="username" label="授权人/账号"></el-table-column>
      </el-table>
      <div class="page" style="width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 15px;">
          <el-pagination
            layout="sizes, prev, pager, next,jumper,total"
            background
            :small="true"
            :page-size="peoplePageSize"
            :total="peoplePageTotal"
            @size-change="peoplePageSizeChange"
            @current-change="peoplePageNumChange"
          ></el-pagination>
          <el-button size="mini" type="primary" @click="getList">GO</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  ApiMethods,
} from '@/assets/js/http-serve/http-methods';
import {email} from "../../assets/js/lib/valid-methods";

export default {
  data() {
    return {
      formInline: {
        tplId: '',
        email: ''
      },
      rules: {
        tplId: [
          {required: true, message: '输入模板编码', trigger: 'blur'},
        ],
        email: [
          {required: true, message: '请输入邮箱号', trigger: 'blur'},
          {validator: email, trigger: 'change'}
        ],
      },
      htmlContent: '',
      tplNo: '',
      tplName: '',
      logDialog: false,
      logList: [],
      peoplePageNum: 1,
      peoplePageSize: 10,
      peoplePageTotal: 0,
    };
  },
  mounted() {
    this.getList()
  },
  methods: {
    insertAfter(newElement,targetElement){
      let parent = targetElement.parentNode;
      if(parent.lastChild == targetElement){
        parent.appendChild(newElement);
      }
      else{
        parent.insertBefore(newElement,targetElement.nextSibling);
      }
    },
    addChapte(){
      let inputList = document.querySelectorAll("input.stamp")
      for(let i=0; i<inputList.length; i++){
        let p = document.createElement('p')
        let obj = `position: ${inputList[i].style.position};
          top: ${inputList[i].style.top};
          left: ${inputList[i].style.left};
          right: ${inputList[i].style.right};
          bottom: ${inputList[i].style.bottom};
          boxSizing: border-box;
          width: 100px;
          height: 64px;
          text-align: center;
          line-height: 64px;
          background: rgba(0, 0, 0, 0.5);
          border: 2px dashed #fff;
          color: #fff`
        p.setAttribute('style', obj)
        p.innerHTML = '签章位置'
        this.insertAfter(p, inputList[i])
      }
    },
    peoplePageSizeChange(size) {
      this.peoplePageNum = 1
      this.peoplePageSize = size
      this.getList()
    },
    peoplePageNumChange(num) {
      this.peoplePageNum = num
      this.getList()
    },
    gotoPage(){
      this.getList()
    },
    searchTemp(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.htmlContent = ''
          this.tplNo = ''
          this.tplName = ''
          const res = await ApiMethods.ApiTemplateController.getHtml({tplId: this.formInline.tplId})
          console.warn(res)
          if (!res.success) return this.$message.error(res.description || '获取模板失败！')
          this.htmlContent = res.data.html
          this.tplNo = res.data.tplNo
          this.tplName = res.data.tplName
          this.$nextTick(() => {
            this.addChapte()
          })
        }
      })
    },
    getList() {
      let params = {
        itemPage: this.peoplePageNum,
        pageSize: this.peoplePageSize,
      }
      ApiMethods.ApiTemplateController.authTplLog(params).then(res => {
        if (!res.success) return this.$message.error(res.description || '获取授权记录数据失败')
        this.logList = res.data
        this.peoplePageNum = res.pageNum
        this.peoplePageSize = res.pageSize
        this.peoplePageTotal = res.total
      }).catch(err => console.error(err))
    },
    openLog() {
      this.getList()
      this.logDialog = true
    },
    closeDialog() {
      this.logList = []
    },
    createCode(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (!this.formInline.tplId) return this.$message.warning('请输入模板ID！')
          const res = await ApiMethods.ApiTemplateController.authTpl({
            tplId: this.formInline.tplId,
            email: this.formInline.email
          })
          if (!res.success) return this.$message.error(res.description || '授权码生成失败！')
          this.$confirm(`授权码生成成功，该授权码已发送至 ${this.formInline.email}`, '系统提示', {
            confirmButtonText: '查看授权记录',
            cancelButtonText: '取消',
            type: 'success'
          }).then(() => {
            this.getList()
            this.logDialog = true
          }).catch(err => console.error(err));
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
.digital {
  height: calc(100vh - 280px);
  overflow-y: auto;
  .box-wrap {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    padding: 15px;

    .line {
      width: 94%;
      margin: 10px 0;
      position: relative;

      p {
        width: 70%;
        float: left;
      }

      a {
        float: right;
        color: #02A7F0;
        cursor: pointer;
      }
    }

    .content {
      width: 100%;
      height: 310px;
      overflow-y: auto;
      position: relative;
      box-sizing: border-box;
      border: 1px solid #666666;
      border-radius: 5px;
      margin-bottom: 10px;
      p.tips {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 120px;
        text-align: center;
        height: 30px;
        font-size: 20px;
        color: #cccccc;
        transform: translate(-50%, -50%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// pages/tpl/digital.vue